import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { Stack } from "@mui/system";
import React, { useState } from "react";
import { createBook } from "../../api/BookApi";

function BookDialog({ data, onUpdate, onCancel }) {
  const [item, setItem] = useState({ ...data }),
    [changes, setChanges] = useState({
      id: data.id,
    }),
    handleClose = (_, reason) => {
      if (reason !== "backdropClick") {
        onCancel && onCancel();
      }
    },
    handleInputChange = (e) => {
      const key = e.target.name,
        value = e.target.value;

      updateItem(key, value);
    },
    handleNumberChange = (e) => {
      const key = e.target.name,
        value = parseFloat(e.target.value) || 0;

      updateItem(key, value);
    },
    handleSubmit = (e) => {
      e.preventDefault();

      createBook(changes).then((book) => {
        onUpdate && onUpdate(book);
      });
    },
    updateItem = (key, value) => {
      let change = {};

      change[key] = value;
      setItem({ ...item, ...change });
      setChanges({ ...changes, ...change });
    };

  return (
    <Dialog fullWidth={true} maxWidth="xs" onClose={handleClose} open={true}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Create a Book</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <TextField
              autoFocus
              fullWidth
              label="Name"
              name="name"
              onChange={handleInputChange}
              required
              sx={{ mt: 1 }}
              value={item.name}
            />
            <TextField
              fullWidth
              inputProps={{
                min: 1,
                max: 66,
                step: 1,
              }}
              label="Sort Order"
              name="sortOrder"
              onChange={handleNumberChange}
              required
              type="number"
              value={item.sortOrder}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button color="inherit" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default BookDialog;
